export default __webpack_public_path__ + "static/assets/aa71937b3517b09fadb740b0a8f506b7.gif";